import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import { compose } from "redux";
import { Modal, ModalBody } from "reactstrap";
import peopleIcon from "../../assets/images/join-team/people.png";
import congratsIcon from "../../assets/images/join-team/congrats.png";
import tryAgainIcon from "../../assets/images/join-team/try-again.png";
import Closeicon from "../../assets/images/charty-party/close.svg";
import * as loaderAction from "../../redux/loader/action";
import * as gameAction from "../../redux/game/action";
import moment from "moment";
import _ from "lodash";
import getTeamApiCall from "../../components/shared/utils/getTeamApiCall";

function JoinTeam(props) {
  const { modal, setModal, gameReducer } = props;
  const join_team_param = _.get(gameReducer, "gamesData.onboarding.join_team");
  const trial_param = _.get(
    gameReducer,
    "gamesData.onboarding.trial_login.agreement.welcome.v2"
  );
  const next_steps_param = _.get(trial_param, "next_steps");
  const currentUser = _.get(gameReducer, "currentUser");
  const [promoCode, setPromoCode] = useState("");
  const [promoEndDate, setPromoEndDate] = useState("");
  const [compnent, set_component] = useState("initial");
  const [magicLinkUserPromocode, setMagicLinkUserPromocode] = useState("");
  const search = useLocation().search;
  console.log(
    magicLinkUserPromocode,
    "magicLinkUserPromocodemagicLinkUserPromocode"
  );

  useEffect(() => {
    const teamcode = new URLSearchParams(search).get("teamcode");
    const magicBranchUrl = new URLSearchParams(search).get("_branch_match_id");
    console.log(magicBranchUrl, "branchURLll==>>");
    if (magicBranchUrl === null) {
      setModal(false);
    }
    console.log(modal, "modalmodalmodalmodal");
    const teamCode = sessionStorage.getItem("teamCode")
      ? sessionStorage.getItem("teamCode")
      : teamcode;
    if (teamCode && teamCode != "") {
      setPromoCode(teamCode);
      checkPromoCode(teamCode);
      sessionStorage.removeItem("teamCode");
    }
  }, [search]);

  const checkPromoCode = (code) => {
    props.setIsLoading(true);
    let url = `${process.env.REACT_APP_CHECK_PROMOCODE}?userId=${currentUser.userId}&promocode=${code}`;
    fetch(url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        accept: "/",
        "accept-language": "en-US,en;q=0.9",
        "sec-fetch-dest": "empty",
        "sec-fatch-mode": "cors",
        "sec-fetch-site": "cross-site",
        "x-api-key": process.env.REACT_APP_API_KEY
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(async (data) => {
        if (data.message === "Promo code exists") {
          const team = getTeamApiCall(code);
          let dataObj = {
            ...currentUser,
            team
          };
          props.setCurrentUser(dataObj);
          setPromoEndDate(data.end_date);
          set_component("sucess");
          props.setIsLoading(false);
        } else {
          set_component("failure");
          props.setIsLoading(false);
        }
      })
      .catch((err) => {
        props.setIsLoading(false);
        set_component("failure");
        // Alert(400, err.message);
      });
  };

  const toggle = () => {
    setModal(!modal);
    props.history.push("/");
  };

  const externalCloseBtn = (
    <button className="modal-icon" onClick={toggle}>
      <img src={Closeicon} alt="closeicon" />
    </button>
  );

  const hendleChangeInput = (e) => {
    let value = e.target.value;
    setPromoCode(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (promoCode.includes("gameapart.app.link")) {
      window.location.href = promoCode;
    } else {
      checkPromoCode(promoCode);
    }
  };

  const handleClose = () => {
    setModal(false);
  };

  const handleFail = () => {
    set_component("initial");
  };

  return (
    <div>
      <Modal
        external={externalCloseBtn}
        isOpen={modal}
        centered
        toggle={toggle}
        backdropClassName="zoom-backdrop"
        className="join-team-modal-wrapper trial-login-modal-wrapper"
      >
        <ModalBody>
          {compnent == "initial" && (
            <div className="join-team-modal">
              <div className="join-team-img">
                <img src={peopleIcon} alt="people" />
              </div>
              <h1 className="title">{join_team_param.prompt_label}</h1>
              <p className="desc">{join_team_param.prompt_text}</p>
              <div className="input-box">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <input
                    type="text"
                    name="input"
                    placeholder={join_team_param.prompt_hint}
                    value={promoCode}
                    onChange={(e) => hendleChangeInput(e)}
                  />
                </form>
              </div>
              <p className="more-help">
                {join_team_param.prompt_small}{" "}
                <a href={join_team_param.prompt_email_link}>
                  {join_team_param.prompt_email_display}
                </a>
              </p>
            </div>
          )}
          {/* First display END  */}

          {/* Second display  */}
          {compnent == "sucess" && (
            <div className="join-team-modal">
              <div className="join-team-img">
                <img src={congratsIcon} alt="congrats" />
              </div>
              <h1 className="title">{join_team_param.success_label}</h1>
              <p className="desc">
                {join_team_param.success_text}{" "}
                {moment(promoEndDate).format("MM/DD/YYYY")}
              </p>
              <div className="my-3">
                <button
                  className="join-team-btn"
                  type="button"
                  onClick={() => handleClose()}
                >
                  {join_team_param.success_button}
                </button>
              </div>
            </div>
          )}
          {/* Second display END  */}

          {/* Third display  */}
          {compnent == "failure" && (
            <div className="join-team-modal">
              <div className="join-team-img">
                <img src={tryAgainIcon} alt="try again" />
              </div>
              <h1 className="title">{join_team_param.fail_label}</h1>
              <p className="desc">{join_team_param.fail_text}</p>
              <div className="my-3">
                <button
                  className="join-team-btn"
                  type="button"
                  onClick={() => handleFail()}
                >
                  {join_team_param.fail_button}
                </button>
              </div>
            </div>
          )}
          {/* Third display END  */}
        </ModalBody>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(JoinTeam);
